function productSpecs(product) {
  if (!product.data.layers) return [];
  return product.data.layers.reduce((a, layer, lindex) => {
    if (layer.type === "glass") {
      if (layer.material?.type === "query") {
        a.push({
          index: lindex,
          name: "Material",
          path: "material",
          makeup: layer.material,
        });
      }

      if (layer.outboard_surface?.type === "query") {
        a.push({
          index: lindex,
          name: "Outboard Surface",
          path: "outboard_surface",
          makeup: layer.outboard_surface,
        });
      }

      if (layer.inboard_surface?.type === "query") {
        a.push({
          index: lindex,
          name: "Inboard Surface",
          path: "inboard_surface",
          makeup: layer.inboard_surface,
        });
      }
    }

    return a;
  }, []);
}

export default productSpecs;
